import V3Adapter from './v3';

export default class GdprConfigurationAdapter extends V3Adapter {}
